import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const DonutChart = ({
    data = [],
    title = "",
    colors = ["#1976d2", "#9c27b0", "#ff9800", "#4caf50", "#f44336"],
    innerRadius = "60%",
    outerRadius = "90%",
    height = 260,
    showLegend = true,
    centerLabel = (ctx) => `${ctx.total}`,
    onSliceClick,
    valueFormatter = (v) => v,
}) => {
    const total = useMemo(() => data.reduce((s, d) => s + (d.value || 0), 0), [data]);

    // percentMap helpful for centerLabel if user passes function
    const percentMap = useMemo(() => {
        const map = {};
        data.forEach((d) => {
            map[d.name] = total ? ((d.value / total) * 100) : 0;
        });
        return map;
    }, [data, total]);



    return (
        <ResponsiveContainer>
            <PieChart>
                <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    paddingAngle={2}
                    onClick={(entry, index) => onSliceClick && onSliceClick(entry, index)}
                    isAnimationActive={true}
                >
                    {data.map((entry, index) => (
                        <Cell
                            key={`cell-${entry.name}-${index}`}
                            fill={entry.color || colors[index % colors.length]}
                        />
                    ))}
                </Pie>

                <Tooltip
                    formatter={(value, name, props) => [valueFormatter(value), name]}
                />

                {showLegend && <Legend verticalAlign="middle" align="right" layout="vertical" />}

            </PieChart>
        </ResponsiveContainer>
    );
};

export default DonutChart;
